// extracted by mini-css-extract-plugin
export default {"rateCont":"Rate_rateCont__4d-8s","cont":"Rate_cont__4ygEa"};